/* eslint-disable no-underscore-dangle, no-undef, max-len, no-unused-vars, quote-props, no-plusplus, no-restricted-syntax, guard-for-in, no-param-reassign, no-var, no-loop-func */
import algoliasearch from 'algoliasearch/lite';
import algoliasearchHelper from 'algoliasearch-helper';
import insightsClient from 'search-insights';
import './search-toggle';

const siteLanguage = document.querySelector('html').getAttribute('lang');
var currentPage = 1;
var previousRefinements = [];
var previousQuery = '';
let isPremium = false;
let sortedFacets = {};
if (drupalSettings && drupalSettings.algolia_search) {
    if (drupalSettings.algolia_search.is_premium !== undefined) {
        isPremium = drupalSettings.algolia_search.is_premium;
    }
    sortedFacets = drupalSettings.algolia_search.sorted_facets;
}

function getIconByType(type) {
    const iconNames = {
        video: 'play_circle',
        series: 'video_library',
        podcast: 'podcasts',
        game: 'games',
        thematic_folder: 'folder',
        digital_book: 'menu_book',
        educational_tool: 'description',
        educational_path: 'conversion_path',
    };
    return iconNames[type] || '';
}

function excerptText(longText, maxLength) {
    if (!longText || longText.length <= maxLength) {
        return longText;
    }
    const excerpt = longText.substring(0, maxLength);
    const lastSpaceIndex = excerpt.lastIndexOf(' ');
    return `${excerpt.substring(0, lastSpaceIndex)}...`;
}

function goBackToTop() {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
    });
}

// Traductions
const translations = {
    en: {
        levels: 'Levels',
        subjects: 'Subjects',
        skills: 'Skills',
        fls: 'French Levels',
        themes: 'Themes',
        selected_filters: 'Selected filters',
        show_more: 'Show more',
        show_less: 'Show less',
        add_bookmark: 'Add to my favorites',
        remove_bookmark: 'Remove from my favorites',
        type: {
            video: 'Videos',
            series: 'Series',
            podcast: 'Podcasts',
            game: 'Games',
            thematic_folder: 'Thematic Folders',
            digital_book: 'Digital Books',
            educational_tool: 'Teaching Tools',
            educational_path: 'Educational Sequences',
        },
        type_singular: {
            video: 'Video',
            series: 'Serie',
            podcast: 'Podcast',
            game: 'Game',
            thematic_folder: 'Thematic Folder',
            digital_book: 'Digital Book',
            educational_tool: 'Teaching Tool',
            educational_path: 'Educational Sequence',
        },
        results: 'results',
        no_results: 'No results',
        locked_tag: 'With subscription',
        with_education_tools: 'With educational tool',
        is_expired_soon: 'Expires soon',
        open_in_newtab: 'This link will open in a new tab',
        pager: {
            next: 'Next',
            prev: 'Previous',
        },
        episodes: 'episodes',
        original_production: 'Original production',
    },
    fr: {
        levels: 'Niveaux',
        subjects: 'Matières',
        skills: 'Compétences',
        fls: 'Niveaux de français',
        themes: 'Thématiques',
        selected_filters: 'Filtres sélectionnés',
        show_more: 'Afficher plus',
        show_less: 'Afficher moins',
        add_bookmark: 'Ajouter à mes favoris',
        remove_bookmark: 'Supprimer de mes favoris',
        type: {
            video: 'Vidéos',
            series: 'Séries',
            podcast: 'Balados',
            game: 'Jeux',
            thematic_folder: 'Dossiers thématiques',
            digital_book: 'Livres numériques',
            educational_tool: 'Outils pédagogiques',
            educational_path: 'Parcours éducatifs',
        },
        type_singular: {
            video: 'Vidéo',
            series: 'Série',
            podcast: 'Balado',
            game: 'Jeu',
            thematic_folder: 'Dossier thématique',
            digital_book: 'Livre numérique',
            educational_tool: 'Outil pédagogique',
            educational_path: 'Parcours éducatif',
        },
        results: 'résultats',
        no_results: 'Aucun résultat',
        locked_tag: 'Avec abonnement',
        with_education_tools: 'Avec outil pédagogique',
        is_expired_soon: 'Expire bientôt',
        open_in_newtab: 'Ce lien s\'ouvrira dans un nouvel onglet',
        pager: {
            next: 'Suivant',
            prev: 'Précédent',
        },
        episodes: 'épisodes',
        original_production: 'Production originale',
    },
};

const attributeMap = {
    school_levels: ['levels.lvl0', 'levels.lvl1', 'levels.lvl2'],
    school_subjects: ['subjects.lvl0', 'subjects.lvl1', 'subjects.lvl2'],
    fls: ['fls.lvl0', 'fls.lvl1', 'fls.lvl2'],
};

function getLevelFromFacetValue(item) {
    return item.split(' > ').length - 1;
}

// Add tag <sup> for school level
const formatSchoolLevelLabel = (label) => {
    const regex = /^(\d{1,3})(\D{1,2})\s/;
    const matches = label.match(regex);
    if (matches && matches.length === 3) {
        return label.replace(matches[0], `${matches[1]}<sup>${matches[2]}</sup>&nbsp`);
    }
    return label;
};

const renderHits = (content) => {
    try {
        const container = document.getElementById('js-custom-hits');
        const hitsArray = content.hits.map((hit) => {
            let duration = 0;
            let durationTag = '';
            const imageUrl = hit.link_main_img ? `${hit.link_main_img}?width=390&height=220` : hit.image_url;
            const resourceLocked = (hit.field_is_free !== undefined && hit.field_is_free === false && !isPremium) ? 'resource-locked' : '';
            let resourceImage = `<div class="resource-thumbnail-placeholder">
                <span class="material-symbols-rounded" aria-hidden="true">photo</span>
            </div>`;
            if (imageUrl) {
                resourceImage = `<img class="resource-image" src="${imageUrl}" alt=""/>`;
            }
            let resourceMeta = '';
            if (hit.content_type === 'video') {
                if (hit.series_name) {
                    resourceMeta = `<div class="resource-episodes">${hit.series_name}</div>`;
                }
                if (hit.duration && Number.isInteger(hit.duration)) {
                    duration = new Date(hit.duration * 1000).toISOString();
                    durationTag = `<span class="resource-duration" aria-hidden="true">${duration.substring(14, 19)}</span><span class="visually-hidden">${duration.substring(11, 19)}</span>`;
                }
            }
            if (hit.content_type === 'series') {
                if (hit.episode_count !== undefined && hit.episode_count !== '') {
                    resourceMeta = `<div class="resource-episodes">${hit.episode_count} ${translations[siteLanguage].episodes}</div>`;
                }
            }
            let schoolLevels = '';
            if (typeof hit.school_levels !== 'undefined' && Array.isArray(hit.school_levels) && hit.school_levels.length) {
                let levels = [];
                if (siteLanguage === 'fr') {
                    levels = hit.school_levels.map((element) => formatSchoolLevelLabel(element));
                } else {
                    levels = hit.school_levels;
                }
                schoolLevels = `<div class="resource-tags-block">
                    <span class="label">${translations[siteLanguage].levels}: </span>
                    <span class="values">${levels.join(', ')}</span>
                </div>
            `;
            }
            let schoolSubjects = '';
            if (typeof hit.school_subjects !== 'undefined' && Array.isArray(hit.school_subjects) && hit.school_subjects.length) {
                schoolSubjects = `<div class="resource-tags-block">
                    <span class="label">${translations[siteLanguage].subjects}: </span>
                    <span class="values">${hit.school_subjects.join(', ')}</span>
                </div>
            `;
            }
            let bookmarkButton = '';
            if (drupalSettings.bookmarks.active) {
                const isHitMarked = drupalSettings.bookmarks.nids.includes(hit.nid.toString());
                bookmarkButton = `<a href="${drupalSettings.bookmarks.manage_ajxPath.replace('NID', hit.nid)}"
                    class="bookmarks button action bookmarks-open-modal use-ajax js-bookmarks-open-modal js-bookmarks-open-modal-${hit.nid} ${isHitMarked ? 'marked' : ''} link-open-modal-marker-lists-${hit.nid}"
                    data-nid="${hit.nid}"
                    rel="nofollow"
                    data-is-marked="${isHitMarked ?? false}"
                >
                <span class="icon-favorite" aria-hidden="true"></span>
                <span class="visually-hidden">${isHitMarked ? translations[siteLanguage].remove_bookmark : translations[siteLanguage].add_bookmark}</span>
                </a>`;
            }
            let tfoOriginalBadge = '';
            let tfoOriginalLabel = '';
            if (hit.is_franco_original) {
                tfoOriginalBadge += '<div class="tfo-original-badge" aria-hidden="true"></div>';
                tfoOriginalLabel += `<div class="tfo-original-label">${translations[siteLanguage].original_production}</div>`;
            }
            let topTags = '';
            if (hit.has_education_tools) {
                topTags = `<div class="education-tools-tag">${translations[siteLanguage].with_education_tools}</div>`;
            }
            if (hit.is_expired_soon) {
                topTags += `<div class="expiration-label-tag">${translations[siteLanguage].is_expired_soon}</div>`;
            }
            if (resourceLocked !== '') {
                topTags += `<div class="lock">${translations[siteLanguage].locked_tag}</div>`;
            }
            let topLabels = '';
            if (topTags) {
                topLabels = `<div class="top-labels">
                    ${topTags}
                </div>`;
            }
            let pathClasses = '';
            if (hit.content_type === 'educational_path') {
                pathClasses = `is-educational-path path-color-${hit.path_color ? hit.path_color : 'purple'}`;
                // Set img bg
                resourceImage = '<div class="resource-thumbnail-placeholder search-educational-path-bg"></div>';
            }
            let folderThemeColor = '';
            if (hit.content_type === 'thematic_folder') {
                folderThemeColor = `thematic-folder-theme-${hit.folder_display_theme ? hit.folder_display_theme : 'default'}`;
            }
            const openInNewTab = `
                    <span class="show-for-sr">${translations[siteLanguage].open_in_newtab}</span>`;
            const hitHtml = `<li class="ais-Hits-item" data-object-id="${hit.objectID}">
                <div class="resource-teaser-search ${pathClasses} ${folderThemeColor} ${resourceLocked} ${hit.has_education_tools ? `${'has-education-tools'}` : ''}" >
                    <div class="resource-inner">
                        <div class="resource-link">
                                ${`<a class="thumbnail" href="${hit.url}">`}
                                ${tfoOriginalBadge}
                                ${topLabels}
                                ${resourceImage}
                                <div class="resource-type">
                                    <span class="material-symbols-rounded">${getIconByType(hit.content_type)}</span>
                                    ${translations[siteLanguage].type_singular[hit.content_type]}
                                </div>
                                ${durationTag}
                            </a>
                            <div class="resource-summary-wrapper">
                                ${tfoOriginalLabel}
                                <div class="resource-title">${hit.title}</div>
                                <div class="resource-meta">${resourceMeta}</div>
                                ${hit.summary !== undefined ? `<div class="resource-summary">${excerptText(hit.summary, 200)}</div>` : ''}
                                <div class="resource-tag">
                                    ${schoolLevels}
                                    ${schoolSubjects}
                                </div>
                            </div>
                        </div>
                        <div class="resource-info">
                            <div class="info-container">
                                <div class="infos">
                                    <a class="resource-title" href="${hit.url}">${hit.title}</a>
                                    ${resourceMeta}
                                </div>
                                ${bookmarkButton}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            `;
            return hitHtml;
        });
        container.innerHTML = `<ul class="ais-Hits-list">${hitsArray.join('')}</ul>`;
        // Ajout du tracking Algolia Insights
        [...document.querySelectorAll('.ais-Hits-item')].forEach((item, index) => {
            const { objectId } = item.dataset;
            const linksToTrack = item.querySelectorAll('.thumbnail, .resource-title');
            linksToTrack.forEach((element) => {
                element.addEventListener('click', (event) => {
                    insightsClient('clickedObjectIDsAfterSearch', {
                        index: content.index,
                        eventName: 'Resource clicked',
                        objectIDs: [objectId],
                        queryID: content.queryID,
                        positions: [index + 1],
                    });
                });
            });
        });
    } catch (err) {
        window.console.log('Error has occurred!', err);
    }
};

const renderCount = (content) => {
    const container = document.getElementById('js-results-count');
    if (content.nbHits > 0) {
        const formattedCount = content.nbHits.toLocaleString('fr-CA');
        container.innerHTML = `${formattedCount} ${translations[siteLanguage].results}`;
    } else {
        container.innerHTML = `${translations[siteLanguage].no_results}`;
    }
};

const renderSimpleFacetList = (content, id, facetName, panelTitle, helper) => {
    try {
        const facetContainer = document.querySelector(id);
        const facetList = content.getFacetValues(facetName, {
            sortBy: (a, b) => sortedFacets[facetName][siteLanguage][`${panelTitle} > ${a.name}`] - sortedFacets[facetName][siteLanguage][`${panelTitle} > ${b.name}`],
        });
        const nbItems = facetList.length;
        const facetHtml = facetList.map((facet, index) => {
            const checked = facet.isRefined ? 'checked' : '';
            return `
                <li class="ais-RefinementList-item ${index > 4 ? 'is-hidden' : ''}">
                    <label class="ais-RefinementList-label">
                        <input type="checkbox" class="ais-RefinementList-checkbox" value="${facet.name}" ${checked} />
                        <span class="ais-RefinementList-labelText">${facet.name}</span>
                    </label>
                </li>
            `;
        }).join('');

        const buttonShowMoreHTML = `<button class="ais-RefinementList-showMore">
            <span>${translations[siteLanguage].show_more}</span>
        </button>`;
        facetContainer.innerHTML = `<div class="ais-Panel">
                                        <div class="ais-Panel-header">
                                            <span>${panelTitle}</span>
                                        </div>
                                        <div class="ais-Panel-body">
                                            <ul class="ais-RefinementList-list">
                                            ${facetHtml}
                                            </ul>
                                        </div>
                                        ${nbItems > 4 ? buttonShowMoreHTML : ''}
                                    </div>`;
        [...facetContainer.querySelectorAll('input[type="checkbox"]')].forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                const facetValue = event.target.value;
                insightsClient('clickedFilters', {
                    index: content.index,
                    eventName: 'Facet Clicked',
                    filters: [`${facetName}:${facetValue}`],
                });
                helper.toggleFacetRefinement(facetName, facetValue).search();
            });
        });
        const buttonShowMore = facetContainer.querySelector('.ais-RefinementList-showMore');
        if (buttonShowMore) {
            buttonShowMore.addEventListener('click', (event) => {
                event.preventDefault();
                if (buttonShowMore.classList.contains('is-active')) {
                    buttonShowMore.classList.remove('is-active');
                    const buttonSpan = buttonShowMore.querySelector('span');
                    buttonSpan.innerHTML = translations[siteLanguage].show_more;
                    const itemsToHide = [...facetContainer.querySelectorAll('.ais-RefinementList-item')].filter((element, index) => index > 4);
                    itemsToHide.forEach((element) => {
                        element.classList.add('is-hidden');
                    });
                } else {
                    buttonShowMore.classList.add('is-active');
                    const buttonSpan = buttonShowMore.querySelector('span');
                    buttonSpan.innerHTML = translations[siteLanguage].show_less;
                    facetContainer.querySelectorAll('.ais-RefinementList-item.is-hidden').forEach((element) => {
                        element.classList.remove('is-hidden');
                    });
                }
            });
        }
    } catch (err) {
        window.console.log('Error has occurred!', err);
    }
};

const createListFromObject = (obj, path = [], facetId = null) => {
    let html = '<ul class="ais-RefinementList-list">';
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const currentLevel = path.length;
            const value = [...path, key]
                .filter((t) => !!t)
                .join(' > ');
            html += `<li class="ais-RefinementList-item ${currentLevel === 1 ? 'is-closed' : ''}">
                <label class="ais-RefinementList-label">
                    <input type="checkbox" class="ais-RefinementList-checkbox" value="${value}" />
                    <span class="ais-RefinementList-labelText">${facetId === '#js-facet-levels' && siteLanguage === 'fr' ? formatSchoolLevelLabel(key) : key}</span>
                </label>`;
            if (currentLevel === 1) {
                html += `
                    <button class="ais-RefinementList-collapseButton">
                        <span><span class="material-symbols-rounded" aria-hidden="true">expand_more</span></span>
                    </button>
                `;
            }
            if (Object.keys(obj[key]).length > 0) {
                html += createListFromObject(obj[key], [...path, key], facetId);
            }
            html += '</li>';
        }
    }
    html += '</ul>';
    return html;
};

const renderHierarchicalFacetList = (content, id, facetName, panelTitle, helper, facetValues) => {
    try {
        const currentRefinements = content.getRefinements();
        const facetContainer = document.querySelector(id);
        let facetPanelHtml = `<div class="ais-Panel">
            <div class="ais-Panel-header">
                <span>${panelTitle}</span>
            </div>
            <div class="ais-Panel-body">
                <div class="ais-RefinementList">`;
        const attributes = attributeMap[facetName];

        const tree = {};
        let rootLevel = '';
        let levels = '';

        facetValues.forEach((facetValue) => {
            const splitLevels = facetValue.name.split(' > ');
            [rootLevel, ...levels] = splitLevels;

            let node = tree;
            levels.forEach((level) => {
                if (!node[level]) {
                    node[level] = {};
                }
                node = node[level];
            });
        });
        facetPanelHtml += createListFromObject(tree, [rootLevel], id);
        facetPanelHtml += `
                </div>
            </div>
        </div>`;
        facetContainer.innerHTML = facetPanelHtml;

        [...facetContainer.querySelectorAll('input[type="checkbox"]')].forEach((element) => {
            const facetValue = element.value;
            const level = getLevelFromFacetValue(facetValue);
            if (currentRefinements.find((refinement) => refinement.name === facetValue)) {
                element.checked = true;
                const parentItem = element.closest('.is-closed');
                if (parentItem) {
                    parentItem.classList.remove('is-closed');
                }
            }
            element.addEventListener('change', (event) => {
                event.preventDefault();
                insightsClient('clickedFilters', {
                    index: content.index,
                    eventName: 'Facet Clicked',
                    filters: [`${attributes[level]}:${facetValue}`],
                });
                helper.toggleFacetRefinement(attributes[level], facetValue).search();
            });
        });
        [...facetContainer.querySelectorAll('.ais-RefinementList-collapseButton')].forEach((element) => {
            const parentContainer = element.closest('.ais-RefinementList-item');
            const buttonSpan = element.querySelector('.material-symbols-rounded');
            element.addEventListener('click', (event) => {
                event.preventDefault();
                if (parentContainer.classList.contains('is-closed')) {
                    parentContainer.classList.remove('is-closed');
                    buttonSpan.textContent = 'expand_less';
                } else {
                    parentContainer.classList.add('is-closed');
                    buttonSpan.textContent = 'expand_more';
                }
            });
        });
    } catch (err) {
        window.console.log('Error has occurred!', err);
    }
};

const renderTypeFacetList = (content, allTypes, helper) => {
    try {
        const facetContainer = document.querySelector('#js-facet-type');
        const currentFacets = content.getFacetValues('content_type', { sortBy: ['name:asc'] });

        // Merge array1 and array2, replacing objects based on 'name'
        const mergedFacetsArray = allTypes.map((obj) => {
            const objFound = currentFacets.find((item) => obj.name === item.name);
            obj.count = 0;
            return objFound || obj;
        });

        const facetHtml = mergedFacetsArray.map((facet) => {
            const isSelected = facet.isRefined ? ' ais-Menu-item--selected' : '';
            const count = (currentFacets.length >= 1 || facet.isRefined) && facet.count > 0 ? `<span class="ais-Menu-count">(${facet.count})</span>` : '';
            const label = `<span class="ais-Menu-label">${translations[siteLanguage].type[facet.name]}</span>`;
            return `
            <li class="ais-Menu-item${isSelected}">
                <a class="ais-Menu-link" href="#" data-value="${facet.name}">${label}${count}</a>
            </li>
            `;
        }).join('');

        facetContainer.innerHTML = `<div class="ais-Menu">
            <ul class="ais-Menu-list">
                ${facetHtml}
            </ul>
        </div>
        `;
        [...facetContainer.querySelectorAll('a')].forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                const facetValue = element.dataset.value;
                helper.clearRefinements('content_type');
                if (!element.closest('.ais-Menu-item--selected')) {
                    helper.addFacetRefinement('content_type', facetValue);
                }
                insightsClient('clickedFilters', {
                    index: content.index,
                    eventName: 'Facet Clicked',
                    filters: [`content_type:${facetValue}`],
                });
                helper.search();
            });
        });
    } catch (err) {
        window.console.log('Error has occurred!', err);
    }
};

const renderEducationalToolsToggle = (content, helper) => {
    try {
        const currentRefinements = content.getRefinements();
        const panelTitle = translations[siteLanguage].with_education_tools;
        const facetContainer = document.querySelector('#js-educational-tools-toggle');
        const facetPanelHtml = `<div class="ais-Panel">
            <div class="refinement-toggle">
                <div class="refinement-toggle-text">${translations[siteLanguage].with_education_tools}</div>
                <input class="refinement-toggle-checkbox" type="checkbox" id="educational-tools-toggle" /><label for="educational-tools-toggle">${panelTitle}</label>
            </div>
        </div>`;
        facetContainer.innerHTML = facetPanelHtml;
        const checkbox = facetContainer.querySelector('.refinement-toggle-checkbox');
        if (currentRefinements.find((refinement) => refinement.attributeName === 'has_education_tools')) {
            checkbox.checked = true;
        }
        checkbox.addEventListener('change', (event) => {
            event.preventDefault();
            const isChecked = event.target.checked;
            if (isChecked) {
                helper.addFacetRefinement('has_education_tools', 'true');
            } else {
                helper.removeFacetRefinement('has_education_tools', 'true');
            }
            helper.search();
        });
    } catch (err) {
        window.console.log('Error has occurred!', err);
    }
};

const renderCurrentRefinements = (content, helper) => {
    let currentRefinements = content.getRefinements();
    // Cache la langue et les excluded facets
    currentRefinements = currentRefinements.filter((refinement) => refinement.attributeName !== 'lang' && refinement.type !== 'exclude');

    // Si les refinements ne sont pas les mêmes, reset à la première page
    if (JSON.stringify(previousRefinements) !== JSON.stringify(currentRefinements)) {
        currentPage = 1;
    }
    // Si la query est différente de la précédente, reset à la première page
    if (previousQuery !== content.query) {
        currentPage = 1;
    }
    previousQuery = content.query;
    previousRefinements = currentRefinements;

    const currentRefinementsContainer = document.querySelector('#js-current-refinements');
    currentRefinementsContainer.innerHTML = `<div class="ais-Panel-header">
        <span>${translations[siteLanguage].selected_filters}</span>
    </div>
    <div class="ais-Panel-body">`;

    const clearRefinementsContainer = document.querySelector('#js-clear-search');

    if (currentRefinements.length > 0) {
        currentRefinementsContainer.classList.remove('hidden');
        clearRefinementsContainer.classList.remove('hidden');
    } else {
        currentRefinementsContainer.classList.add('hidden');
        clearRefinementsContainer.classList.add('hidden');
    }
    const currentRefinementsHtml = currentRefinements.map((refinement) => {
        const lastIndex = refinement.name.lastIndexOf('>');
        let label = (lastIndex === -1) ? refinement.name : refinement.name.substring(lastIndex + 1).trim();
        if (refinement.attributeName === 'content_type') {
            label = translations[siteLanguage].type[refinement.name];
        }
        if (refinement.attributeName === 'has_education_tools') {
            label = translations[siteLanguage].with_education_tools;
        }
        return `
        <li class="ais-CurrentRefinements-item">
            <span class="ais-CurrentRefinements-label">${label}</span>
            <button class="ais-CurrentRefinements-delete"
            type="button" data-type="${refinement.type}" data-attribute="${refinement.attributeName}"
            data-value="${refinement.name}">✕</button>
        </li>
        `;
    }).join('');
    currentRefinementsContainer.innerHTML += `<ul class="ais-CurrentRefinements-list">${currentRefinementsHtml}</ul></div>`;
    [...currentRefinementsContainer.querySelectorAll('button')].forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            const { type } = element.dataset;
            const { attribute } = element.dataset;
            const { value } = element.dataset;
            if (type === 'facet') {
                helper.removeFacetRefinement(attribute, value);
            }
            if (type === 'disjunctive') {
                helper.removeDisjunctiveFacetRefinement(attribute, value);
            }
            helper.search();
        });
    });
};

const renderPagination = (content, helper) => {
    const totalPages = content.nbPages;

    // Number of pages to show in the pagination list
    const numPagesToShow = 10;

    // Calculate the starting and ending page numbers to show
    let startPage = Math.max(1, currentPage - Math.floor(numPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + numPagesToShow - 1);

    // Adjust the starting page number if necessary
    if (endPage - startPage + 1 < numPagesToShow) {
        startPage = Math.max(1, endPage - numPagesToShow + 1);
    }

    const paginationContainer = document.querySelector('#js-pagination');
    const div = document.createElement('div');
    div.classList.add('ais-Pagination');
    const ul = document.createElement('ul');
    ul.classList.add('ais-Pagination-list');

    // Add "Previous" button if not on the first page
    if (currentPage > 1) {
        const liPrev = document.createElement('li');
        liPrev.classList.add('ais-Pagination-item', 'ais-Pagination-item--previousPage');
        const aPrev = document.createElement('a');
        aPrev.classList.add('ais-Pagination-link');
        aPrev.href = '#';
        aPrev.textContent = translations[siteLanguage].pager.prev;
        aPrev.addEventListener('click', (event) => {
            event.preventDefault();
            currentPage -= 1;
            if (currentPage < 1) {
                currentPage = 1;
            }
            helper.setPage(currentPage - 1);
            helper.search();
            goBackToTop();
        });
        liPrev.appendChild(aPrev);
        ul.appendChild(liPrev);
    }

    // Generate pagination list items
    for (let i = startPage; i <= endPage; i++) {
        const li = document.createElement('li');
        li.classList.add('ais-Pagination-item');
        const a = document.createElement('a');
        a.classList.add('ais-Pagination-link');
        a.href = `?page=${i}`;
        a.textContent = i;
        a.setAttribute('aria-label', `Page ${i}`);
        if (i === currentPage) {
            li.classList.add('ais-Pagination-item--selected');
        }
        a.addEventListener('click', (event) => {
            event.preventDefault();
            helper.setPage(i - 1);
            currentPage = i;
            helper.search();
            goBackToTop();
        });
        li.appendChild(a);
        ul.appendChild(li);
    }

    // Add "Next" button if not on the last page
    if (currentPage < endPage) {
        const liNext = document.createElement('li');
        liNext.classList.add('ais-Pagination-item', 'ais-Pagination-item--nextPage');
        const aNext = document.createElement('a');
        aNext.classList.add('ais-Pagination-link');
        aNext.href = '#';
        aNext.textContent = translations[siteLanguage].pager.next;
        aNext.addEventListener('click', (event) => {
            event.preventDefault();
            currentPage += 1;
            helper.setPage(currentPage - 1);
            helper.search();
            goBackToTop();
        });
        liNext.appendChild(aNext);
        ul.appendChild(liNext);
    }

    div.appendChild(ul);
    paginationContainer.innerHTML = '';
    paginationContainer.appendChild(div);
};

const handleHierarchialFacetRefinement = (urlParams, param, helper) => {
    if (urlParams.has(param)) {
        const values = urlParams.getAll(param);
        values.forEach((item) => {
            helper.toggleFacetRefinement(param.slice(0, -2), item);
        });
    }
};

const initSearchFromQueryString = (helper) => {
    // Get the URL search parameters
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('query')) {
        const query = urlParams.get('query');
        previousQuery = query;
        helper.setQuery(query);
        const searchInput = document.querySelector('#js-searchbox-input');
        const searchReset = document.querySelector('.ais-SearchBox-reset');
        searchInput.value = query;
        searchReset.classList.remove('is-hidden');
    }
    if (urlParams.has('page')) {
        const page = parseInt(urlParams.get('page'), 10);
        currentPage = page;
        helper.setPage(page - 1);
    }
    if (urlParams.has('content_type')) {
        const type = urlParams.get('content_type');
        helper.addFacetRefinement('content_type', type);
    }
    if (urlParams.has('skills[]')) {
        const skills = urlParams.getAll('skills[]');
        skills.forEach((item) => {
            helper.addFacetRefinement('skills', item);
        });
    }
    if (urlParams.has('themes[]')) {
        const skills = urlParams.getAll('themes[]');
        skills.forEach((item) => {
            helper.addFacetRefinement('themes', item);
        });
    }
    handleHierarchialFacetRefinement(urlParams, 'levels.lvl0[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'levels.lvl1[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'levels.lvl2[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'subjects.lvl0[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'subjects.lvl1[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'subjects.lvl2[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'fls.lvl0[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'fls.lvl1[]', helper);
    handleHierarchialFacetRefinement(urlParams, 'fls.lvl2[]', helper);
    helper.search();
};

const getInitialHierarchicalFacets = (results, facetName) => {
    const attributes = attributeMap[facetName];

    const facetValuesLvl1 = results.content.getFacetValues(attributes[1], {
        sortBy: (a, b) => sortedFacets[facetName][siteLanguage][a.name] - sortedFacets[facetName][siteLanguage][b.name],
    });
    const facetValuesLvl2 = results.content.getFacetValues(attributes[2], {
        sortBy: (a, b) => sortedFacets[facetName][siteLanguage][a.name] - sortedFacets[facetName][siteLanguage][b.name],
    });
    const facetValues = [...facetValuesLvl1, ...facetValuesLvl2];

    // school_levels need to be sorted by taxonomy order because 10e annee is before 9e annee alphabitically.
    if (facetName === 'school_levels') {
        return facetValues;
    }
    // sort facetValues by facetName
    return facetValues.toSorted((a, b) => a.name.localeCompare(b.name, 'fr', { ignorePunctuation: true }));
};

const setInsightsToken = (results) => {
    insightsClient('getUserToken', {}, (err, userToken) => {
        if (err) {
            /* eslint-disable-next-line no-console */
            console.error(err);
            return;
        }
        insightsClient('setUserToken', userToken);
    });
};

const updateQueryString = (results, helper) => {
    const urlParams = new URLSearchParams();
    const refinements = results.getRefinements();

    // Find and set 'content_type' refinement
    const resourceTypeRefinement = refinements.find((element) => (element.attributeName === 'content_type' && element.type === 'facet'));
    if (resourceTypeRefinement) {
        urlParams.set('content_type', resourceTypeRefinement.name);
    }

    // Filter out the 'lang' and 'content_type' refinement
    const filteredRefinements = refinements.filter(
        (refinement) => refinement.attributeName !== 'lang' && refinement.attributeName !== 'content_type',
    );

    // Create an object to hold the refined values for each attribute
    const refinedAttributes = {};

    // Loop through each refinement and add it to the refinedAttributes object
    filteredRefinements.forEach((refinement) => {
        if (!refinedAttributes[refinement.attributeName]) {
            // If the attribute is not yet defined, set it to an array containing the refinement value
            refinedAttributes[refinement.attributeName] = [refinement.name];
        } else {
            // If the attribute is already defined, add the refinement value to the array
            refinedAttributes[refinement.attributeName].push(refinement.name);
        }
    });

    // Loop through the refinedAttributes object and add each attribute to the URLSearchParams object
    Object.keys(refinedAttributes).forEach((attributeName) => {
        const values = refinedAttributes[attributeName];
        values.forEach((value) => {
            urlParams.append(`${attributeName}[]`, value);
        });
    });

    // On ajoute la query
    if (results.query !== '') {
        urlParams.set('query', results.query);
    }

    // On ajoute la page courante à l'URL
    if (currentPage > 1) {
        urlParams.set('page', currentPage);
    }
    const queryString = urlParams.toString();
    const newRelativePathQuery = (queryString !== '') ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    window.history.pushState(null, '', newRelativePathQuery);
};

if (document.querySelector('.search-results')) {
    const searchContainer = document.querySelector('.search-container');
    const indexName = drupalSettings.algolia_search.index_name;
    const isStudent = drupalSettings.algolia_search.is_student;
    const searchClient = algoliasearch(drupalSettings.algolia_search.app_id, drupalSettings.algolia_search.algolia_key);
    const typesExludedForStudent = ['thematic_folder', 'educational_tool', 'educational_path'];

    insightsClient('init', {
        appId: drupalSettings.algolia_search.app_id,
        apiKey: drupalSettings.algolia_search.algolia_key,
        useCookie: true,
    });

    const helper = algoliasearchHelper(searchClient, indexName, {
        facets: ['content_type', 'resource_type', 'skills', 'themes', 'lang', 'has_education_tools'],
        disjunctiveFacets: ['levels.lvl0', 'levels.lvl1', 'levels.lvl2', 'subjects.lvl0', 'subjects.lvl1', 'subjects.lvl2', 'fls.lvl0', 'fls.lvl1', 'fls.lvl2'],
        hitsPerPage: 20,
        clickAnalytics: true,
    });

    helper.addFacetRefinement('lang', siteLanguage);
    if (isStudent) {
        typesExludedForStudent.forEach((ressourceType) => {
            helper.addFacetExclusion('content_type', ressourceType);
        });
    }

    const searchInput = document.querySelector('#js-searchbox-input');
    const searchReset = document.querySelector('.ais-SearchBox-reset');
    const searchSubmit = document.querySelector('#js-searchbox-submit');

    searchSubmit.addEventListener('click', (event) => {
        event.preventDefault();
        helper.setQuery(searchInput.value).search();
    });

    searchInput.addEventListener('keyup', (event) => {
        if (event.target.value !== '') {
            searchReset.classList.remove('is-hidden');
        }
        helper.setQuery(event.target.value).search();
    });
    searchReset.addEventListener('click', (event) => {
        searchInput.value = '';
        searchReset.classList.add('is-hidden');
        helper.setQuery('').search();
    });

    document.querySelector('.clear-refinements-button').addEventListener('click', (event) => {
        helper.clearRefinements();
        helper.addFacetRefinement('lang', siteLanguage);
        helper.search();
    });
    let allTypeFacets = [];
    let allLevelsFacets = [];
    let allSubjectsFacets = [];
    let allFlsFacets = [];

    helper.on('result', (event) => {
        try {
            const { results } = event;
            renderTypeFacetList(results, allTypeFacets, helper);
            renderEducationalToolsToggle(
                results,
                helper,
            );
            renderHierarchicalFacetList(
                results,
                '#js-facet-levels',
                'school_levels',
                translations[siteLanguage].levels,
                helper,
                allLevelsFacets,
            );
            renderHierarchicalFacetList(
                results,
                '#js-facet-subjects',
                'school_subjects',
                translations[siteLanguage].subjects,
                helper,
                allSubjectsFacets,
            );
            renderHierarchicalFacetList(
                results,
                '#js-facet-fls',
                'fls',
                translations[siteLanguage].fls,
                helper,
                allFlsFacets,
            );
            renderSimpleFacetList(results, '#js-facet-skills', 'skills', translations[siteLanguage].skills, helper);
            renderSimpleFacetList(results, '#js-facet-themes', 'themes', translations[siteLanguage].themes, helper);
            renderCount(results);
            renderHits(results);
            renderCurrentRefinements(results, helper);
            renderPagination(results, helper);
            setInsightsToken(results);
            updateQueryString(results, helper);
            document.querySelectorAll('.skeleton-placeholder').forEach((elem) => elem.remove());
            Drupal.attachBehaviors();
        } catch (err) {
            window.console.log('Error has occurred!', err);
        }
    });

    // On fait une première recherche pour avoir toutes les facettes de type
    helper.searchOnce()
        .then((results) => {
            allTypeFacets = results.content.getFacetValues('content_type', { sortBy: ['name:asc'] });
            // On retire les dossier thématiques si l'utilisateur est un élève
            if (isStudent) {
                allTypeFacets = allTypeFacets.filter((type) => !typesExludedForStudent.includes(type.name));
            }

            allLevelsFacets = getInitialHierarchicalFacets(results, 'school_levels');
            allSubjectsFacets = getInitialHierarchicalFacets(results, 'school_subjects');
            allFlsFacets = getInitialHierarchicalFacets(results, 'fls');

            initSearchFromQueryString(helper);
            document.querySelector('#js-results-count').focus();
        });
}
